module.exports = __webpack_public_path__ + "img/logo-fg-image.48c97ba7.png";